var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"align-center"},[_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',[_c('div',{staticClass:"d-flex justify-center"},[_c('router-view')],1)])],1)],1),_c('SpinnerOverlay')],1)}
var staticRenderFns = []

export { render, staticRenderFns }